'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var dsnKeys = 'source protocol user pass host port path'.split(' ');
var dsnPattern = /^(?:(\w+):)?\/\/(?:(\w+)(:\w+)?@)?([\w\.-]+)(?::(\d+))?(\/.*)/; //eslint-disable-line no-useless-escape

var parseDsn = function parseDsn(dsn) {
  var _dsn$match$reduce = dsn.match(dsnPattern).reduce(function (parsed, current, index) {
    return Object.assign({}, parsed, _defineProperty({}, dsnKeys[index], current));
  }, {}),
      protocol = _dsn$match$reduce.protocol,
      host = _dsn$match$reduce.host,
      path = _dsn$match$reduce.path;

  var project = path.substr(path.lastIndexOf('/') + 1);

  return { protocol: protocol, project: project, host: host };
};

module.exports.parseDsn = parseDsn;